<script lang="ts">
  import { sessionStore } from "../lib/stores/session";
</script>

<div
  class="flex flex-col"
  class:bg-fixed={$sessionStore.currentPath === "/"}
  class:fooji-bg-image={$sessionStore.currentPath === "/"}>
  <slot name="bodyScripts" />
  <slot name="header" />
  <div class="w-full content">
    <slot name="content" />
  </div>
  <slot name="footer" />
</div>

<style>
  .content {
    margin-top: 3rem;
    min-height: calc(100vh - 9rem);
  }

  @media screen and (min-width: 1024px) {
    .content {
      margin-top: 4.6875rem;
      min-height: calc(100vh - 4.6875rem);
    }
  }
</style>
